import { FC, useState } from 'react'
import { FormEntryField, QueryPageableResponse } from '../../../core/type'
import { useQuery } from '@apollo/client'
import { ItemCategory, ItemCategoryLevel } from '../type'
import { GetItemCategoriesForLookup } from '../graphql/item-category.graphql'
import { Combo, ComboOption } from '../../../core/component'
import Enumerable from 'linq'

export const ItemSearchCategoryMulti: FC<FormEntryField<number[]> & {
  level: ItemCategoryLevel,
  disabled: boolean
}> = ({value, onChange, disabled, level}) => {
  const [search, setSearch] = useState<string>('')
  const {data, loading} = useQuery(GetItemCategoriesForLookup, {
    variables: {
      request: {
        take: 20,
        skip: 0,
        level,
        title: search,
      },
    },
  })

  const mapToOptions = (data?: QueryPageableResponse<ItemCategory, 'itemCategoriesFind'>): ComboOption<ItemCategory>[] =>
    Enumerable.from((data?.itemCategoriesFind.data ?? []))
      .select(e => ({
        value: e.id,
        display: `${e.id} - ${e.title}`,
        item: e,
      }))
      .toArray()

  return <Combo<ItemCategory, number[]>
    allowMultiple
    disabled={disabled}
    loading={loading}
    value={value}
    size='middle'
    className='w-100'
    options={mapToOptions(data)}
    onChange={value => onChange!(value as number[])}
    onSearch={setSearch}
  />
}